import HTTP from './http-interceptor';
import { DASHBOARD, DESAFIO_PERSONAL } from '../constants';

const IndividualChallengeService = {
    
    getScore: (player, area) => {
        return HTTP.get(`${DESAFIO_PERSONAL.SCORE}${player}/${area}`);
    },
    searchPlayers: (player, area, qry, cancelToken) => {
        return HTTP.get(`${DESAFIO_PERSONAL.BUSCAR_JUGADOR}${area}/${player}?qry=${qry}`, { cancelToken });
    },
    canPlay: (area) => {
        return HTTP.get(`${DESAFIO_PERSONAL.PUEDE_RETAR}${area}`);
    },
    randomChallenge: (player, area) => {
        return HTTP.get(`${DESAFIO_PERSONAL.ALEATORIO}${area}/${player}`);
    },
    save: (challenge, area, stats) => {
        return HTTP.post(`${DESAFIO_PERSONAL.ACTUALIZA}${challenge}/${area}`, stats);
    },
    getSuggestions: (player, area) => {
        return HTTP.get(`${DESAFIO_PERSONAL.SUGERENCIAS}${area}/${player}?limit=${4}`);
    },
    getYourTurn: (player, area) => {
        return HTTP.get(`${DESAFIO_PERSONAL.MI_TURNO}${area}/${player}`);
    },
    getTheirTurn: (player, area) => {
        return HTTP.get(`${DESAFIO_PERSONAL.SU_TURNO}${area}/${player}`);
    },
    getFirstChallenge: (player, area) => {
        return HTTP.get(`${DESAFIO_PERSONAL.PRIMER_DESAFIO}${area}/${player}`);
    },
    getLeaderboard: (player, area, campaign = '') => {
        return HTTP.get(`${DASHBOARD.LEADERBOARD_V2}${area}/${player}/${campaign}`);
    },
    challenge: (player, area, opponent) => {
        return HTTP.get(`${DESAFIO_PERSONAL.DIRECTO}${area}/${player}/${opponent}`);
    },
    myTurn: (challenge, opponent) => {
        return HTTP.get(`${DESAFIO_PERSONAL.RESPONDER_MI_TURNO}${challenge}/${opponent}`);
    },
    getChallengeStatus: (player, area, opponent, challenge) => {
        return HTTP.get(`${DASHBOARD.DETALLE_RONDA}${area}/${player}/${opponent}/${challenge}`);
    },
    getChallengeRecords: (player, area, limit) => {
        return HTTP.get(`${DASHBOARD.HISTORIAL_RETOS}${area}/${player}/${limit}`);
    },
    existsChallengeRecords: (player, area) => {
        return HTTP.get(`${DASHBOARD.EXISTE_HISTORIAL_RETOS}${area}/${player}`);
    },
}

export default IndividualChallengeService;